import { CODE_VERSION_CHANGE } from '../types';
import { createAction } from '@reduxjs/toolkit';

export const codeVersionChange = createAction<
  string,
  typeof CODE_VERSION_CHANGE
>(CODE_VERSION_CHANGE);
